"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.SegmentedBoxMessage = exports.boxSizes = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ScrollBox = _interopRequireDefault(require("../layout/ScrollBox"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MessagesConstants = require("../general/messages/MessagesConstants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @enum {string}
 * @alias SegmentedBox.boxSizes
 */
var boxSizes = {
  /** none */
  AUTO: "none",

  /** 220 */
  XS: 220,

  /** 440 */
  SM: 440,

  /** 660 */
  MD: 660,

  /** 1100 */
  LG: 1100,

  /** full */
  FULL: "full"
};
/**
 * @class SegmentedBox
 * @desc A layout component to create a bounded scrolling box with optional content above and below.
 *       Used to create the SelectionList component.
 *
 * @param {string} [className]
 *     Class name(s) to add to the top-level container/div.
 * @param {string} [data-id]
 *     Defines the "data-id" for top-level HTML container.
 * @param {boolean} [border=false]
 *     Draws a border around the box.
 * @param {node} [bottomPanel]
 *     Content that goes below the scrolling box.
 * @param {SegmentedBox.boxSizes} [height="none"]
 *     Bounds the height of the whole box.
 * @param {number} [innerHeight]
 *     Bounds the height of the scrolling box.
 * @param {string} [scroll-box-data-id]
 *     Set the data-id for the scrolling box.
 * @param {node} [topPanel]
 *     Content that goes above the scrolling box.
 * @param {SegmentedBox.boxSizes} [width="none"]
 *     Bounds the width of the whole box.
 *
 */

/**
 * @class SegmentedBoxMessage
 * @desc A special message component that goes in the top panel.
 *
 * @param {string} [className]
 *     Class name(s) to add to the top-level container/div.
 * @param {string} [data-id]
 *     Defines the "data-id" for top-level HTML container.
 * @param {string} [message]
 *     Text of the message.
 * @param {Messages.MessageTypes} [type=WARNING]
 *     Color of message box.
 *
 */

exports.boxSizes = boxSizes;

var SegmentedBoxMessage = function SegmentedBoxMessage(_ref) {
  var dataId = _ref["data-id"],
      children = _ref.children,
      type = _ref.type;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-id": dataId,
    className: (0, _classnames.default)("segmented-box__message", "segmented-box__message--".concat(type))
  }, children);
};

exports.SegmentedBoxMessage = SegmentedBoxMessage;
SegmentedBoxMessage.propTypes = {
  "data-id": _propTypes.default.string,
  message: _propTypes.default.string,
  type: _propTypes.default.oneOf((0, _values.default)(_MessagesConstants.MessageTypes))
};
SegmentedBoxMessage.defaultProps = {
  message: "",
  type: _MessagesConstants.MessageTypes.WARNING
};

var SegmentedBox = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SegmentedBox, _React$Component);

  var _super = _createSuper(SegmentedBox);

  function SegmentedBox() {
    (0, _classCallCheck2.default)(this, SegmentedBox);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(SegmentedBox, [{
    key: "_setSize",
    value: function _setSize() {
      var lockMinSize = this.props.lockMinSize;

      if (lockMinSize || lockMinSize !== false && !this._inPopover) {
        if (this.boxEl) {
          if (!this._height || this._height < this.boxEl.clientHeight) {
            this._height = this.boxEl.clientHeight;
          }

          if (!this._width || this._width < this.boxEl.clientWidth) {
            this._width = this.boxEl.clientWidth;
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // if this code causes problems, tell Tyler
      // if it doesn't until at least 2021-01-01, buy Tyler a beer
      var isInPopover = function isInPopover() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          classList: []
        },
            _ref2$classList = _ref2.classList,
            classList = _ref2$classList === void 0 ? [] : _ref2$classList,
            parentNode = _ref2.parentNode;

        if (classList.contains) {
          if (classList.contains("details-content") || classList.contains("popover-display")) {
            return true;
          }
        }

        return parentNode ? isInPopover(parentNode) : false;
      };

      this._inPopover = isInPopover(this.boxEl);

      this._setSize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._setSize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          dataId = _this$props["data-id"],
          _this$props$border = _this$props.border,
          border = _this$props$border === void 0 ? false : _this$props$border,
          bottomPanel = _this$props.bottomPanel,
          children = _this$props.children,
          height = _this$props.height,
          innerHeight = _this$props.innerHeight,
          scrollBoxDataId = _this$props["scroll-box-data-id"],
          topPanel = _this$props.topPanel,
          width = _this$props.width;
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": dataId,
        className: (0, _classnames.default)("segmented-box", {
          "segmented-box--border": border,
          "segmented-box--full-width": width === "full"
        }),
        style: {
          maxWidth: width,
          maxHeight: height,
          minWidth: this._width || "auto",
          minHeight: this._height || "auto"
        },
        ref: function ref(el) {
          return _this.boxEl = el;
        }
      }, topPanel && /*#__PURE__*/_react.default.createElement("div", {
        className: "segmented-box__top-panel"
      }, topPanel), /*#__PURE__*/_react.default.createElement(_ScrollBox.default, {
        className: "segmented-box__scroll-box",
        height: innerHeight,
        "data-id": scrollBoxDataId
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "segmented-box__content"
      }, children)), bottomPanel && /*#__PURE__*/_react.default.createElement("div", {
        className: "segmented-box__bottom-panel"
      }, bottomPanel));
    }
  }]);
  return SegmentedBox;
}(_react.default.Component);

(0, _defineProperty2.default)(SegmentedBox, "propTypes", {
  "data-id": _propTypes.default.string,
  border: _propTypes.default.bool,
  bottomPanel: _propTypes.default.node,
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  innerHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  "scroll-box-data-id": _propTypes.default.string,
  topPanel: _propTypes.default.node,
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
});
(0, _defineProperty2.default)(SegmentedBox, "defaultProps", {
  border: false,
  height: "none",
  width: "none"
});
var _default = SegmentedBox;
exports.default = _default;